export const accepted = {
  validate: value => !!value
};
